// extracted by mini-css-extract-plugin
export default {"container":"styles__container___u0N4Y","inner":"styles__inner___wC7V-"};